import { render, staticRenderFns } from "./EditPrimaryInfoModal.vue?vue&type=template&id=7b7373fa&scoped=true"
import script from "./EditPrimaryInfoModal.vue?vue&type=script&lang=js"
export * from "./EditPrimaryInfoModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b7373fa",
  null
  
)

export default component.exports